<template>
  <div>
    projects-config
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>

</style>
